import React from 'react';
import { FormattedNumber } from 'react-intl';

class FormatCurrency extends React.Component {
  render() {
    return(
        <FormattedNumber value={ this.props.value } style="currency" currency={ 'ARS' } />
    )
  }
}

export { FormatCurrency };
